import { render, staticRenderFns } from "./ProducerFormInfo.vue?vue&type=template&id=06cb77f6&scoped=true&"
import script from "./ProducerFormInfo.vue?vue&type=script&lang=ts&"
export * from "./ProducerFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProducerFormInfo.vue?vue&type=style&index=0&id=06cb77f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cb77f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
